// Calendar jQuery Plugin
// MODULE_DESCRIPTION

$(function () {
    var Calendar = function (element, options) {
        this.calendar = $(element);

        // Default module configuration
        this.defaults = {
            labels: {
                label1: 'label1',
                label2: 'label2',
            },
            classes: {
                class1: 'class1',
                class2: 'class2',
                states: {
                    active: 'is-active',
                },
            },
        };

        // Merge default classes with window.project.classes
        this.classes = $.extend(true, this.defaults.classes, (window.project ? window.project.classes : {}));

        // Merge default labels with window.project.labels
        this.labels = $.extend(true, this.defaults.labels, (window.project ? window.project.labels : {}));

        // Merge default config with custom config
        this.config = $.extend(true, this.defaults, options || {});

        // Calendar element
        this.calendarElement = this.calendar.find('.calendar-full');

        this.publicMethods = {
            methodName: $.proxy(function () {
                // console.log('methodName function called');
            }, this),
        };

        this.init();
    };

    $.extend(Calendar.prototype, {

        // Component initialization
        init: function () {
            this.bindEvents();
        },

        bindEvents: function () {
            $(window).on('scroll', $.proxy(function () {
                var calendarOffset = this.calendar.offset().top;
                var $window = $(window);
                // If calendar hit top
                if ($window.scrollTop() >= calendarOffset) {
                    this.calendarElement.find('.calendar-body').css('overflow', 'auto');
                    // Si mobile
                    if ($window.width() < 768) {
                        this.calendar.addClass('is-mobile-activated');
                    }
                } else {
                    this.calendarElement.find('.calendar-body').css('overflow', 'hidden');
                    this.calendar.removeClass('is-mobile-activated');
                }
            }, this));
        },
    });

    $.fn.calendar = function (options) {
        this.each($.proxy(function (index, element) {
            var $element = $(element);

            // Return early if this $element already has a plugin instance
            if ($element.data('calendar')) return;

            // Pass options to plugin constructor
            var calendar = new Calendar(element, options);

            // Add every public methods to plugin
            for (var key in calendar.publicMethods) {
                this[key] = calendar.publicMethods[key];
            }

            // Store plugin object in this $element's data
            $element.data('calendar', calendar);
        }, this));

        return this;
    };
});
